import '../../../App.css';
import './Sculc2023.css';

const Sculc2023Schedule = () => {

    return (
        <div className="sculc2023-page">
            <div className="sculc2023-header-container">
                <img
                    src="/images/sculc2024/2024_Program-1.png"
                    alt="Header"
                    className="sculc2023-header-image"
                />  
                <h1 className="sculc2023-title">Schedule</h1>
            </div>
            <div className="sculc2023-navbar">
                <div className="sculc2023-navbar-container">
                    <a href="/sculc-2023" className="sculc2023-links">Home</a>
                    <a href="/sculc-2023-program" className="sculc2023-links">Programs</a>
                    <a href="/sculc-2023-schedule" className="sculc2023-links">Schedule</a>
                    <a href="/sculc-2023-presentation" className="sculc2023-links">Presentation</a>
                    <a href="/sculc-2023-photo" className="sculc2023-links">Photos</a>
                </div>
            </div>
            <div className="sculc2023-program-container">
                <img src="/images/sculc2023/sculc2023-schedule.png" width="100%" title="program-pdf" style={{ aspectRatio: "8/12" }} alt="program-schedule" />
            </div>
            <div style={{height: "5vh"} }></div>
            
                
        </div>
    );
};

export default Sculc2023Schedule;
